<div
    class="images-gallery-container"
    [class.background-hover]="backgroundOnHover"
    hImageGalleryScroll
    [currentIndex]="currentIndex"
    [animationElement]="animation"
    [containerElement]="galleryWrapper"
    [attr.role]="'tablist'"
    [attr.aria-labelledby]="prefixTab + '-image-gallery'">
    <span
        [attr.id]="prefixTab + '-image-gallery'"
        i18n="@@hermes.accessibility.product-images-gallery-title"
        hSrOnlyNoSnippet>
        Image gallery
    </span>

    <div #galleryWrapper class="gallery-wrapper">
        @if(productInput) { @for (asset of assets; track asset; let idx = $index) {
        <div class="gallery-item">
            <img
                class="gallery-img"
                [class.checked]="idx === currentIndex"
                hI18nAsset
                [tag]="asset.tag ?? asset.type"
                [imageTitle]="productInput.title"
                [url]="asset.url"
                [hI18nAttr]="'alt'"
                alt=""
                [attr.id]="'image-title-' + idx"
                aria-hidden="true"
                [attr.src]="asset.type === 'image' ? (asset.url | productImageSeoUrl
                    : {
                          slug: productInput.slug,
                          imageSize: thumbnailSize,
                          templateType: productInput.templateType,
                      } ): asset.posterUrl" />
            @if(asset.type === 'video') {
            <span class="play-icon"> <h-svg-icon [name]="'play-media'"></h-svg-icon> </span>
            }
            <button
                class="gallery-button"
                [attr.role]="'tab'"
                [attr.aria-labelledby]="'image-title-' + idx"
                [attr.aria-selected]="idx === currentIndex"
                [attr.aria-controls]="prefixerAriaControls(idx)"
                tabindex="{{ idx === currentIndex ? 0 : -1 }}"
                id="{{ prefixTab }}{{ idx }}"
                (click)="handleThumbnailSelectedWithClick($event, idx)"
                (keydown)="handleThumbnailSelectedWithKey($event)">
            </button>
        </div>
        } }
        <div #animation class="animation"></div>
    </div>
</div>
